<template>
  <div>
    <admin-navbar/>
    <div class="relative w-screen flex flex-row flex-no-grow flex-no-shrink overflow-y-hidden z-0" style="height: calc(100vh - 3rem);">
      <mini-menu @getAdminMenu="getAdminMenu"/>
      <component v-bind:is="selectedMenu" class="flex flex-row w-screen" style="height: inherit;" @getAdminMenu="getAdminMenu"></component>
    </div>
    <div v-if="role !== 'externalAdmin'" class="loader">
      <loader/>
    </div>
    <div class="toaster">
      <toaster/>
    </div>
  </div>
</template>

<script>
import AdminNavbar from '@/components/Admin/AdminNavbar'
import DoctorMain from '@/components/Admin/DoctorMain'
import UploadDoctorRoster from '@/components/Admin/UploadDoctorRoster'
import DoctorSchedule from '@/components/DoctorRoster/DoctorSchedule'
import DoctorChatAvailability from '@/components/Admin/DoctorChatAvailability'
import MiniMenu from '@/components/MiniMenu'
import AdminLeftPane from '@/components/Admin/AdminLeftPane'
import Loader from '@/components/common/Loader'
import Toaster from '@/components/common/Toaster'
import {mapGetters} from 'vuex'
import Appointments from '@/components/Appointments/Appointments.vue'
export default {
  components: {
    AdminNavbar,
    AdminLeftPane,
    MiniMenu,
    Loader,
    Toaster,
    DoctorMain,
    UploadDoctorRoster,
    DoctorSchedule,
    DoctorChatAvailability,
    Appointments
  },
  data () {
    return {
      selectedMenu: 'doctor-main'
    }
  },
  computed: {
    ...mapGetters({
      isActiveChatPresent: 'consultation/isActiveChatPresent',
      isActivePastChatPresent: 'pastConsultation/isPastChatPresent',
      requests: 'consultationRequest/getRequests',
      alreadyAssignedRequests: 'consultationRequest/getOthersAcceptedRequest',
      patientCancelledRequests: 'consultationRequest/getCancelledRequest',
      activeSection: 'configuration/getActiveSection',
      role: 'configuration/getRole'
    }),
    incomingRequests: function () {
      this.consultRequests = this.requests
      this.othersAcceptedRequests = this.alreadyAssignedRequests
      this.cancelledRequests = this.patientCancelledRequests
      return this.requests
    },
    isActiveChat: function () {
      if (this.activeSection === 'connected' && this.isActiveChatPresent === true) {
        return true
      } else if (this.activeSection === 'consults' && this.isActivePastChatPresent === true) {
        return true
      }
      return false
    }
  },
  watch: {
    role: {
      immediate: true,
      handler (newRole) {
        if (newRole === 'externalAdmin') {
          this.$store.dispatch('configuration/setActiveAdminMiniMenu', 'Appointments')
          this.selectedMenu = 'appointments'
        }
      }
    }
  },
  methods: {
    getAdminMenu: function (menu) {
      this.selectedMenu = menu
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Admin/AdminHome.vue